import script from "./PatchColor.vue?vue&type=script&setup=true&lang=js"
export * from "./PatchColor.vue?vue&type=script&setup=true&lang=js"

import "./PatchColor.vue?vue&type=style&index=0&id=71b252de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b252de"]])

export default __exports__